import {BaseEditor} from "form/Editor";
import {MetronicMultiButtonManyOfEditor} from "../metronic/MetronicMultiButtonManyOfEditor";
import {SelectionKey, SelectionOption} from "./OneOfEditor";

export class ManyOfEditor extends BaseEditor<SelectionKey[]> {

    private _value: SelectionKey[];
    private _bannedKeys: SelectionKey[] = [];
    private readonly _options: SelectionOption[];
    private defaultValue: SelectionKey[];
    private readonly RenderComponent: (props: { editor: ManyOfEditor }) => JSX.Element;

    constructor(options: SelectionOption[], RenderComponent?: (props: { editor: ManyOfEditor }) => JSX.Element, value?: SelectionKey[]) {
        super();
        if (options.length === 0) {
            throw new Error("Select editor cannot be created without any options");
        }
        if (value !== undefined) {
            value.forEach(val => {
                if (!options.find(o => o.key === val)) {
                    throw new Error("Incorrectly created 'many of' editor - current value has invalid option");
                }
            })
        }

        this.RenderComponent = RenderComponent ?? MetronicMultiButtonManyOfEditor
        this._value = value !== undefined ? value : [];
        this._options = options;
        this.defaultValue = this._value;
    }

    get value(): SelectionKey[] {
        return this._value;
    }

    get options(): SelectionOption[] {
        return this._options;
    }

    get bannedKeys(): SelectionKey[] {
        return this._bannedKeys;
    }

    banKeys(keys: SelectionKey[]): void {
        // By default, unbanned keys will be selected
        const keysToAddBack = this._bannedKeys.filter(bannedKey => !keys.includes(bannedKey));
        this._value = [...this._value, ...keysToAddBack];

        this._bannedKeys = keys;
        this._value = this._value.filter(v => !this._bannedKeys.includes(v));
        this.notifyListeners();
    }

    isOptionKeyBannedOrAbsent(optionKey: SelectionKey): boolean {
        const option = this.options.find(o => o.key === optionKey);
        if (!option) {
            return true;
        }
        return this._bannedKeys.includes(optionKey);
    }

    populate(value: SelectionKey[]): void {
        const valuesFilteredToKnownAndUnbanned = value.filter(v => !this.isOptionKeyBannedOrAbsent(v));
        this._value = valuesFilteredToKnownAndUnbanned;
        this.notifyListeners();
    }

    toggle = (option: SelectionKey) => {
        if (this.value.includes(option)) {
            this.populate(this.value.filter(v => v != option));
        } else {
            if (!this.isOptionKeyBannedOrAbsent(option)) {
                this.populate([...this.value, option]);
            } else {
                console.warn("Disallowed to select banned option", option)
            }
        }
    }

    reset(): void {
        this._value = this.defaultValue;
        this.notifyListeners();
    }

    commit(): void {
    }

    Component = (): JSX.Element => {
        const ThisRenderComponent = this.RenderComponent;
        return <ThisRenderComponent editor={this}/>;
    }

    get errorList(): string[] {
        return [];
    }

    get isValid(): boolean {
        return true;
    }

}
